module.exports = __webpack_public_path__ + "static/media/sa-banner.b8a56e84.jpg";